module.exports = "<svg viewBox=\"0 0 14 4\"><rect width=\"14\" height=\"4\" data-name=\"-\" rx=\"2\"></rect></svg>"